"use client";
import React, { useContext } from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import RichText from "@/components/organisms/Richtext";
import { FaqItemProps } from "./types";
import { GlobalContext } from "@/contexts/SiteDataContext";
import "./styles.scss";

const FaqItem = ({ title, content, compact }: FaqItemProps) => {
  const siteDataComplete = useContext(GlobalContext).context.siteDataComplete;

  return (
    <Collapsible.Root className={`${compact ? "faq-item faq-item--compact" : "faq-item"}`}>
      <Collapsible.Trigger className="faq-item__title">{title}</Collapsible.Trigger>

      <Collapsible.Content className="faq-item__content">
        <RichText
          content={content}
          siteDataComplete={siteDataComplete}
        />
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default FaqItem;
